import { useQuery } from "@tanstack/react-query"
import type { DocumentListResult } from "../../domain/entities/document"
import { makeGetDocuments } from "../../domain/use-cases/get-documents"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const getDocuments = makeGetDocuments(httpDocumentRepository)

const REFRESH_INTERVAL_MS = 10_000

const TERMINAL_STATUSES = new Set<string>(["completed", "failed"])

const shouldPollDocuments = (data: DocumentListResult | undefined): boolean =>
  data !== undefined &&
  data.items.some((doc) => !TERMINAL_STATUSES.has(doc.status))

type Params = { kbId: string; page: number; limit: number }

export const useDocuments = (params: Params) =>
  useQuery({
    queryKey: ["documents", params],
    queryFn: () => getDocuments(params),
    enabled: !!params.kbId,
    refetchInterval: (query) =>
      shouldPollDocuments(query.state.data) ? REFRESH_INTERVAL_MS : false,
  })
